
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/apple/callback",
      function () {
        return require("private-next-pages/auth/apple/callback/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/apple/callback"])
      });
    }
  